import { useIntl } from "react-intl";
import styled from "styled-components";
const formatter = (num, per,f) => {
  return num === undefined ? "-" : per ? (num / 100).toFixed(2) : f ? num.toFixed(f) :num;
};

export default function Attributes({ equip = {}, simple = false, intlfn }) {
  // const intl = useIntl()
  const getMessage = (id) => {
    return intlfn.formatMessage({
      id,
    });
  };
  return (
    <Attribute>
      <AttributeRow>
        <AttributeItem>
          {!simple ? (
            <>
              <AttributeText>{getMessage("耐久值")}</AttributeText>
              <div className="text text1 m10" style={{ padding: ".5rem" ,fontSize: "1.2rem" }}>
                {formatter(equip.remain_durability, 100)}/
                {formatter(equip.durability, 100)}
              </div>
            </>
          ) : null}
          {/* quality 0-9 普通 10-19 罕见 20-29 史诗 30-39 神话 40及以上 传说 */}
          <div
            className="text text2 m10"
            style={{ padding: ".5rem" ,fontSize: "1.2rem" }}
          >
            {equip.quality <= 9 && equip.quality >= 0
              ? getMessage("普通")
              : equip.quality <= 19
              ? getMessage("罕见")
              : equip.quality <= 29
              ? getMessage("史诗")
              : equip.quality <= 39
              ? getMessage("神话")
              : equip.quality >= 40
              ? getMessage("传说")
              : "--"}
          </div>
        </AttributeItem>
        {!simple ? "|" : null}
        <AttributeItem>
          {!simple ? (
            <>
              {" "}
              <AttributeText>{getMessage("收益率")}</AttributeText>
              <div className="text3">
                {formatter(equip.income_rate, 0 ,2)}RT/{getMessage("天")}
              </div>
            </>
          ) : null}
          <div
            className="text text4 m10"
            style={{ padding:  ".5rem" ,fontSize: "1.2rem" }}
          >
            {equip.upgradeable !== undefined
              ? equip.upgradeable
                ? getMessage("可升级")
                : getMessage("不可升级")
              : "--"}
          </div>
        </AttributeItem>
        {!simple ? "|" : null}
        <AttributeItem>
          {!simple ? (
            <>
              {" "}
              <AttributeText>{getMessage("已获收益")}</AttributeText>{" "}
              <div className="text3">{formatter(equip.income, 0 ,2)}RT</div>
            </>
          ) : null}
          <div
            className="text text5 m10"
            style={{ padding: ".5rem" ,fontSize:  "1.2rem" }}
          >
            {simple
              ? (formatter(equip.durability,100) +"/"+formatter(equip.durability,100))
              : formatter(equip.copyId || equip.copy_id) +
                "/" +
                formatter(equip.copies)}
          </div>
        </AttributeItem>
      </AttributeRow>
    </Attribute>
  );
}

const Attribute = styled.div`
  margin-top: 1.5rem;
  padding: 0 .5rem;
`;

const AttributeRow = styled.div`
  display: flex;
  line-height: 1.4rem;
  color: #c4c4c4;
`;
const AttributeItem = styled.div`
  width: 50%;
  flex: 0.5;
  margin-bottom: 1.0rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.3rem;

  color: #000000;
  .m10 {
    display: inline-block;
    min-width: 80%;
    /* margin-left: 1.0rem;
    margin-right: 1.0rem; */
  }
  .text {
    border-radius: 1.3rem;
    font-weight: 400;
    font-size: 1.1rem;
    line-height: 1.3rem;
    color: #ffffff;
    padding: 2px .5rem;
  }
  .text1 {
    background: #f57627;
  }
  .text2 {
    background: #cca4d9;
    margin-top: .7rem;
  }
  .text3 {
    font-weight: 500;
    font-size: 1.3rem;
    line-height: 2.4rem;
    white-space: nowrap;
    color: #000000;
  }
  .text4 {
    background: #34bd6f;
    margin-top: .7rem;
    white-space: nowrap;
  }
  .text5 {
    background: #f57627;
    margin-top: .7rem;
  }
`;
const AttributeText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.3rem;
  color: #969696;
  display: inline-block;
  min-width: 4.0rem;
  text-align: left;
  margin-bottom: .8rem;
`;
